import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

import { computeServiceChoiceOptions } from '../utils/compute-service-choice-options';

export const computeChooseArticleServiceContext = ({
  article,
  view,
  requestView,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelations;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  view.warranty.editable = true;
  view.prices.thresholds.client.editable = true;
  view.prices.thresholds.organization.editable = true;

  view.defects.canAddRemoveDefect = true;
  view.defects.fields.description.editable = true;
  view.defects.fields.photo.editable = true;
  view.defects.fields.context.editable = true;
  view.defects.fields.toBeRepaired.editable = true;
  view.defects.fields.brandResponsibility.toggle.editable = true;
  view.defects.fields.brandResponsibility.exceptionalCoverage.toggle.editable = true;

  /**
   * SERVICES
   */
  view.services.choice.shown = true;
  view.services.choice.editable = true;
  view.services.choice.serviceOptions = computeServiceChoiceOptions(
    article,
    view,
    'service-choice'
  );

  view.services.actions.canAddAction = true;
  view.services.actions.canRemoveAction = true;
  view.services.actions.fields.description.editable = true;
  view.services.actions.fields.context.editable = true;
  view.services.actions.fields.photo.editable = true;
  view.services.actions.fields.associatedDefects.editable = true;
  view.services.actions.fields.additionalInfo.editable = true;
  view.services.actions.fields.brandResponsibility.editable = true;
  view.services.actions.fields.organizationPrice.editable = requestView.organizationPrice.editable;
  view.services.actions.fields.spareParts.organizationPrice.editable =
    requestView.organizationPrice.editable;
  view.services.actions.fields.spareParts.canAddRemoveSparePart = true;
  view.services.actions.fields.spareParts.referenceNumber.editable = true;
  view.services.actions.fields.spareParts.quantity.editable = true;
  // If all actions already have a defined workshop price, then there won't necessarily be
  // an `accept_dispatch_proposal` task for the user to set the client price.
  // Therefore, the client price needs to be set from the `choose_article_service` task.
  view.services.actions.fields.organizationPrice.required =
    article.snapshot.serviceChoice === 'care-repair' &&
    article.snapshot.articleActions.every((action) => !!action.workshopPrice) &&
    article.step?.step === 'service-choice' &&
    !!article.step.config.requireOrganizationPrice;

  view.services.actions.fields.spareParts.organizationPrice.required =
    article.snapshot.serviceChoice === 'care-repair' &&
    article.snapshot.articleActions.every((action) => !!action.workshopPrice) &&
    article.step?.step === 'service-choice' &&
    !!article.step.config.requireOrganizationPrice;

  view.services.dispatch.editable = true;

  view.services.exchange.exchangeType.editable = true;
  view.services.exchange.replacementProduct.editable = true;
  view.services.exchange.stockLocation.editable = true;
  view.services.exchange.organizationPrice.editable = requestView.organizationPrice.editable;
  view.services.exchange.organizationPrice.required = true;

  view.services.none.shown = false;
  view.services.exchangeArchival.shown = false;
  view.services.refund.shown = false;
};
